<main #dcgcontainer>
  <article #fs fullscreen-able [class.is-active]="isActive" style="background-color: white;">

    <!-- Status tabs + File Type toggle share one row: tabs on the left, one chip
         per File Type filter option on the right. -->
    <div class="dcg-tabs-row">

      <!-- Status Tabs — outside the card, at the top (Design Tab 4 style) -->
      <mat-tab-group
        class="custom-tab-group groupOfCss dcg-tab4-group"
        [@.disabled]="true"
        [disableRipple]="true"
        fitInkBarToContent
        [selectedIndex]="activeTabIndex"
        (selectedIndexChange)="onTabChange($event)">
        <mat-tab *ngFor="let tab of tabs; let i = index">
          <ng-template mat-tab-label>
            <div style="position: relative;" (click)="onTabChange(i)">
              <svg viewBox="98.131 168.337 199.483 47.954"
                  width="199.483"
                  height="47.954"
                  xmlns="http://www.w3.org/2000/svg">
                <g transform="matrix(1.454693, 0, 0, 1.00074, 84.396833, 158.40268)">
                  <path d="M 10.5 18.318 C 10.5 14.315 13.219 11.068 16.572 11.068 L 127.573 11.068 C 129.959 11.068 132.122 12.737 133.105 15.331 L 144.823 46.263 C 146.64 51.061 143.703 56.5 139.291 56.5 L 16.572 56.5 C 13.219 56.5 10.5 53.254 10.5 49.25 L 10.5 18.318 Z"
                      style="stroke: rgb(225, 225, 225); fill: rgb(255, 255, 255); paint-order: fill; stroke-width: 1.62904px;"/>
                </g>
              </svg>
              <div class="dcg-page-name"
                  [ngStyle]="{ 'font-weight': activeTabIndex === i ? 'bold' : 'normal' }">
                {{ tab.label }}
                <span class="dcg-tab-count">{{ tabCounts[i] || 0 }}</span>
              </div>
            </div>
          </ng-template>
          <ng-template matTabContent></ng-template>
        </mat-tab>
      </mat-tab-group>

      <!-- File Type toggle — every file type the filter knows about, with the
           record count from the outstanding-errors/field-count API. Picking one
           changes the File Type filter itself, which reloads the grid. -->
      <div class="dcg-filetype-toggle" *ngIf="fileTypeOptions.length > 0">
        <button
          type="button"
          class="dcg-filetype-chip"
          *ngFor="let fileType of fileTypeOptions"
          [class.is-active]="isFileTypeActive(fileType)"
          [attr.aria-pressed]="isFileTypeActive(fileType)"
          [disabled]="!canSwitchFileType"
          (click)="onFileTypeSelect(fileType)">
          <span class="dcg-filetype-name">{{ fileType.name }}</span>
          <span
            class="dcg-filetype-count"
            [class.is-muted]="!fileTypeCount(fileType)"
          >{{ fileTypeCount(fileType) ?? '–' }}</span>
        </button>
      </div>

    </div>

    <div class="dcg-container" >

      <div class="mb-1">
        <icon-chart
          [showErrorColumns]="showErrorColumns"
          [showFailColumns]="showFailColumns"
          [errorCount]="errorCount"
          [failCount]="failCount"
          (toggleErrorColumns)="toggleErrorColumns()"
          (toggleFailColumns)="toggleFailColumns()"
          [headerConfig]="this.item.config?.widget_header_config"
          [heading]="heading"
          [chartName]="'DataCorrectionGrid'"
          [config]="dcgcontainer"
          [expand]="fs"
          [fullscreen]="isFullscreen"
          [item]="item"
          [data]="filteredRowData"
          [excelConfig]="excelColumns"
          [pageKey]="pageKey"
          [apiKey]="12345"
          (typeToSearch)="onSearch($event)"
          (screenChanges)="fullscreenChanges($event)"
        ></icon-chart>
      </div>
      <!-- [rowDataCount]="filteredRowData.length" -->
      <div><loading *ngIf="isLoading"> </loading></div>
      <!-- AG Grid -->
      <div class="dcg-grid-wrapper">
        <ag-grid-angular
          class="ag-theme-alpine dcg-grid"
          [style.height]="(this.item.config?.['fixed_height'] && !isFullscreen) ? this.item.config?.['fixed_height']+'px' :'100%'"
          [columnDefs]="columnDefs"
          [rowData]="filteredRowData"
          [defaultColDef]="defaultColDef"
          [rowHeight]="rowHeight"
          [headerHeight]="headerHeight"
          [pagination]="pagination"
          [paginationPageSize]="paginationPageSize"
          [context]="gridContext"
          [isExternalFilterPresent]="isExternalFilterPresent"
          [doesExternalFilterPass]="doesExternalFilterPass"
          [getContextMenuItems]="getContextMenuItems"
          (gridReady)="onGridReady($event)"
          (cellClicked)="onCellClicked($event)"
        ></ag-grid-angular>
      </div>

    </div>
  </article>
</main>

<!-- Edit Record Modal — rendered at body level via CDK Overlay -->
<ng-template #modalTemplate>
  <div class="modal-card" (click)="$event.stopPropagation()">

    <!-- Modal Header -->
    <div class="modal-header">
      <span class="modal-title">Edit Record</span>
      <span class="modal-source-id" *ngIf="selectedRow?.source_patient_id">
        Source patient-ID {{ selectedRow?.source_patient_id }}
      </span>
      <div class="modal-status-pills">
        <span class="status-pill error-pill">
          <span class="badge-dot error-color"></span>
          Error: {{ selectedRow?.errors }} Open
        </span>
        <span class="status-pill fail-pill">
          <span class="badge-dot fail-color"></span>
          Fail: {{ selectedRow?.fails }} Open
        </span>
        <span class="record-nav-label">{{ currentRecordIndex + 1 }} / {{ filteredRowData.length }}</span>
      </div>
      <div class="modal-nav-btns">
        <button class="nav-btn" (click)="openPrevRecord()" [disabled]="currentRecordIndex === 0">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 8L8 12M8 12L12 16M8 12H16M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        <button class="nav-btn" (click)="openNextRecord()" [disabled]="currentRecordIndex === filteredRowData.length - 1">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 8L16 12M16 12L12 16M16 12H8M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
      <button class="close-btn" (click)="requestCloseModal()">
        <mat-icon class="matIcons" >close</mat-icon>
      </button>
    </div>

    <!-- Modal Body -->
    <div class="modal-body">
      <div class="modal-loading" *ngIf="isModalLoading">
        <loading></loading>
      </div>
      <div class="changelog-state" *ngIf="!isModalLoading && modalFields.length === 0">
        <div class="changelog-state-text">No error or fail records found for this record.</div>
      </div>
      <table class="edit-table" *ngIf="!isModalLoading && modalFields.length > 0">
        <thead>
          <tr>
            <!-- <th class="col-header">RECORD RAW KEY</th> -->
            <th class="col-header">COLUMN</th>
            <th>ORIGINAL VALUE</th>
            <th>CORRECT VALUE</th>
            <th class="info-th">INFO</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let field of modalFields">
            <!-- <td class="record-key-cell">{{ selectedRow?.du_universal_record_key || '-' }}</td> -->
            <td class="col-name-cell">{{ field.column }}</td>
            <td>
              <span
                class="orig-value-cell"
                [class.orig-error]="field.status === 'error'"
                [class.orig-fail]="field.status === 'fail'"
              >{{ field.originalValue }}</span>
            </td>
            <td>
              <ng-container [ngSwitch]="field.dataType">
                <!-- I -> Number input (numeric values only) -->
                <input
                  *ngSwitchCase="'I'"
                  class="fix-value-input"
                  type="number"
                  inputmode="numeric"
                  [(ngModel)]="field.fixValue"
                  (keydown)="onNumberKeydown($event)"
                  placeholder="Enter number..."
                  [class.has-error]="getFieldError(field)"
                  [disabled]="isSubmittedRecord"
                />
                <!-- D -> Material datepicker, so the calendar matches the app
                     instead of the browser's own. `fixValue` stays the yyyy-MM-dd
                     string the payload, validation and dirty-tracking all read;
                     `fixDate` is only what the picker binds to. Read-only by
                     design: the date comes from the calendar, never a typed
                     string the adapter would have to guess at. -->
                <div class="date-field" *ngSwitchCase="'D'">
                  <input
                    class="fix-value-input date-input"
                    [class.has-error]="getFieldError(field)"
                    [matDatepicker]="datePicker"
                    [(ngModel)]="field.fixDate"
                    (dateChange)="onDatePicked(field)"
                    (click)="datePicker.open()"
                    placeholder="Select date..."
                    readonly
                    [disabled]="isSubmittedRecord"
                  />
                  <button
                    type="button"
                    class="date-clear-btn"
                    *ngIf="field.fixDate && !isSubmittedRecord"
                    matTooltip="Clear"
                    (click)="clearDate(field)"
                  >
                    <mat-icon class="matIcons">close</mat-icon>
                  </button>
                  <mat-datepicker-toggle
                    class="date-toggle"
                    matTooltip="Pick a date"
                    [for]="datePicker"
                    [disabled]="isSubmittedRecord"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #datePicker panelClass="dcg-datepicker"></mat-datepicker>
                </div>
                <!-- C (default) -> Text input (any string) -->
                <input
                  *ngSwitchDefault
                  class="fix-value-input"
                  type="text"
                  [(ngModel)]="field.fixValue"
                  placeholder="Enter fix value..."
                  [class.has-error]="getFieldError(field)"
                  [disabled]="isSubmittedRecord"
                />
              </ng-container>
              <div class="fix-value-error" *ngIf="getFieldError(field)">
                {{ getFieldError(field) }}
              </div>
            </td>
            <td class="info-actions-cell">
              <div class="info-actions-wrap">
                <button
                  class="info-icon-btn comment-icon"
                  (click)="toggleCommentPopover(field.id, $event)"
                  [class.active]="activeCommentRow === field.id && showCommentPopover"
                >
                  <mat-icon matTooltip="Comment" class="matINFOIcons" svgIcon='message_circle'></mat-icon>
                </button>
                <button
                  class="info-icon-btn copy-icon"
                  (click)="toggleInfoTooltip($event, field.id)"
                  [class.active]="showInfoTooltip && activeInfoRow === field.id"
                >
                  <mat-icon matTooltip="Info" class="matINFOIcons" svgIcon='annotation_info'></mat-icon>
                </button>

                <!-- Info Legend Popover -->
                <div
                  class="info-legend-popover"
                  *ngIf="showInfoTooltip && activeInfoRow === field.id"
                  (click)="$event.stopPropagation()"
                >
                  <!-- <div class="legend-item">
                    <span class="badge-dot error-color"></span>
                    <div class="legend-text">
                      <div class="legend-title">Column Description</div>
                      <div class="legend-desc">We do not have DV information so please ignore this...</div>
                    </div>
                  </div> -->
                  <div class="legend-item">
                    <span class="badge-dot defect-color"></span>
                    <div class="legend-text">
                      <!-- dv_cd_desc -->
                      <div class="legend-title">Actual Defects</div>
                      <div class="legend-desc">{{ field.actualDefect || '-' }}</div>
                    </div>
                  </div>
                  <div class="legend-item">
                    <span class="badge-dot success-color"></span>
                    <div class="legend-text">
                      <!-- dv_error_msg -->
                      <div class="legend-title">Data Validation Check</div>
                      <div class="legend-desc">{{ field.validationCheck || '-' }}</div>
                    </div>
                  </div>
                </div>

                <!-- Comment Popover -->
                <div
                  class="comment-popover"
                  *ngIf="showCommentPopover && activeCommentRow === field.id"
                  (click)="$event.stopPropagation()"
                >
                  <!-- <div class="popover-field">
                    <label class="popover-label">Action</label>
                    <select class="popover-select" [(ngModel)]="commentAction">
                      <option>Ignore DV Check</option>
                      <option>Actual Defects</option>
                      <option>Data Validation Check</option>
                    </select>
                  </div> -->
                  <div class="popover-field">
                    <label class="popover-label">Comment</label>
                    <textarea
                      class="popover-textarea"
                      [(ngModel)]="field.comments"
                      rows="3"
                      placeholder="Enter comment..."
                      [disabled]="!field.fixValue || isSubmittedRecord"
                    ></textarea>
                    <div class="popover-hint" *ngIf="!field.fixValue">
                      Comments can only be added after this field has been corrected.
                    </div>
                  </div>
                  <div class="popover-footer">
                    <button class="btn-popover-cancel" (click)="closeCommentPopover()">Cancel</button>
                    <button class="btn-popover-save" (click)="saveComment()" [disabled]="!field.fixValue || isSubmittedRecord">Save</button>
                  </div>
                </div>

              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Modal Footer -->
    <div class="modal-footer">
      <button class="btn-change-log" *ngIf="!isFixRecord" (click)="viewChangeLog()">View Change Log</button>
      <div class="modal-footer-right">
        <!-- <button class="btn-ignore" (click)="ignoreRecord()">Ignore Record</button> -->
        <button class="btn-save-next" *ngIf="!isSubmittedRecord" (click)="save()" [disabled]="!canSave">Save</button>
        <button class="btn-submit" *ngIf="!isSubmittedRecord" (click)="submit()" [disabled]="!canSubmit">{{ isSaving ? 'Saving...' : 'Submit' }}</button>
      </div>
    </div>

  </div>
</ng-template>

<!-- View Change Log Modal — rendered at body level via CDK Overlay -->
<ng-template #changeLogTemplate>
  <div class="changelog-card" (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="changelog-header">
      <button class="changelog-back-btn" (click)="closeChangeLog()" aria-label="Back">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <span class="changelog-title">View Change Log</span>

      <div class="changelog-meta" *ngIf="!isChangeLogLoading && !changeLogError">
        <span class="status-pill error-pill" *ngIf="selectedRow">
          <span class="badge-dot error-color"></span>
          Error: {{ selectedRow?.errors }} Open
        </span>
        <span class="status-pill fail-pill" *ngIf="selectedRow">
          <span class="badge-dot fail-color"></span>
          Fail: {{ selectedRow?.fails }} Open
        </span>
        <span class="changelog-status-badge" *ngIf="changeLogStatusDesc">
          <span class="badge-dot success-color"></span>
          {{ changeLogStatusDesc }}
        </span>
      </div>

      <button class="close-btn" (click)="closeChangeLog()">
        <mat-icon class="matIcons">close</mat-icon>
      </button>
    </div>

    <!-- Body -->
    <div class="changelog-body">
      <div class="modal-loading" *ngIf="isChangeLogLoading">
        <loading></loading>
      </div>

      <!-- Error state -->
      <div class="changelog-state changelog-error" *ngIf="!isChangeLogLoading && changeLogError">
        <div class="changelog-state-text">{{ changeLogError }}</div>
        <button class="btn-retry" (click)="loadChangeLog()">Retry</button>
      </div>

      <!-- Empty state -->
      <div class="changelog-state" *ngIf="!isChangeLogLoading && !changeLogError && changeLogRows.length === 0">
        <div class="changelog-state-text">No change history found for this record.</div>
      </div>

      <!-- Table -->
      <div class="changelog-table-wrap" *ngIf="!isChangeLogLoading && !changeLogError && changeLogRows.length > 0">
        <ag-grid-angular
          class="ag-theme-alpine changelog-grid"
          [columnDefs]="changeLogColumnDefs"
          [rowData]="changeLogRows"
          [defaultColDef]="changeLogDefaultColDef"
          [headerHeight]="40"
          [suppressCellFocus]="true"
          [domLayout]="'autoHeight'"
          (gridReady)="onChangeLogGridReady($event)"
        ></ag-grid-angular>
      </div>
    </div>

  </div>
</ng-template>
